import { render, staticRenderFns } from "./card_bg_icon_right.vue?vue&type=template&id=2ed1d68a"
import script from "./card_bg_icon_right.vue?vue&type=script&lang=js"
export * from "./card_bg_icon_right.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports